import { render } from "./Create.vue?vue&type=template&id=41efe2da&scoped=true&ts=true"
import script from "./Create.ts?vue&type=script&lang=ts"
export * from "./Create.ts?vue&type=script&lang=ts"

import "./Create.scss?vue&type=style&index=0&id=41efe2da&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41efe2da"]])

export default __exports__